module.exports = __webpack_public_path__ + "img/MPC.31fcdcd6.png";